// sqlite-wasm で cards.db から CardDefDto[] を読み込む catalog loader (= ADR-0028 §A/§B)。
//
// sql.js (= read-only in-memory SQLite) を用いて public/cards.db を fetch し、
// SELECT でカード定義を取得して CardDefDto[] に map する。
// 1 度だけ load して module-level cache に保持する (= engine.ts の initPromise パターン)。

import initSqlJs from "sql.js";
import sqlWasmUrl from "sql.js/dist/sql-wasm.wasm?url";

import type { CardDefDto } from "@/bindings/CardDefDto";

let catalogPromise: Promise<CardDefDto[]> | null = null;

export function loadCatalog(): Promise<CardDefDto[]> {
  catalogPromise ??= _doLoad();
  return catalogPromise;
}

async function _doLoad(): Promise<CardDefDto[]> {
  const SQL = await initSqlJs({ locateFile: () => sqlWasmUrl });
  const res = await fetch("/cards.db");
  if (!res.ok) {
    throw new Error(`cards.db の取得に失敗しました: ${res.status} ${res.statusText}`);
  }
  const buf = await res.arrayBuffer();
  const db = new SQL.Database(new Uint8Array(buf));

  const result = db.exec(
    "SELECT card_id, card_id_str, name, card_type, cost, atk, def, level, race, status_flags, spell_speed FROM cards",
  );
  db.close();

  if (result.length === 0) {
    return [];
  }

  const { columns, values } = result[0];
  const idxOf = (col: string): number => columns.indexOf(col);

  const iCardId = idxOf("card_id");
  const iCardIdStr = idxOf("card_id_str");
  const iName = idxOf("name");
  const iCardType = idxOf("card_type");
  const iCost = idxOf("cost");
  const iAtk = idxOf("atk");
  const iDef = idxOf("def");
  const iLevel = idxOf("level");
  const iRace = idxOf("race");
  const iStatusFlags = idxOf("status_flags");
  const iSpellSpeed = idxOf("spell_speed");

  return values.map((row): CardDefDto => {
    const atkVal = row[iAtk];
    const defVal = row[iDef];
    return {
      card_id: Number(row[iCardId]),
      card_id_str: String(row[iCardIdStr]),
      name: String(row[iName]),
      card_type: String(row[iCardType]),
      cost: Number(row[iCost]),
      atk: atkVal !== null && atkVal !== undefined ? Number(atkVal) : null,
      def: defVal !== null && defVal !== undefined ? Number(defVal) : null,
      level: Number(row[iLevel]),
      race: JSON.parse(String(row[iRace])) as string[],
      status_flags: JSON.parse(String(row[iStatusFlags])) as string[],
      spell_speed: String(row[iSpellSpeed]),
    };
  });
}
